import { RobotTaskSchedulerEntityModel } from "src/store/models/entity/robotTaskScheduler/entity";
import { RobotTaskSchedulerHelperModel } from "src/store/models/entity/robotTaskScheduler/helper";

export const encooRobotTaskSchedulerModels = {
  entity: RobotTaskSchedulerEntityModel,
  helper: RobotTaskSchedulerHelperModel,
};
